import { createCustomDimensionsRepository } from '../../customDimensionsRepository';

const setDidomiExperimentDimension = () => {
  if (
    window.didomiState?.didomiExperimentId &&
    window.didomiState?.didomiExperimentUserGroup
  ) {
    const { set } = createCustomDimensionsRepository();
    set({
      customParam: 'misc',
      value: `${window.didomiState.didomiExperimentId}|${window.didomiState.didomiExperimentUserGroup}`,
    });
  }
};

export const handleDidomiInit = () => {
  window.didomiOnReady = window.didomiOnReady || [];
  setDidomiExperimentDimension();
  window.didomiOnReady.push(() => {
    setDidomiExperimentDimension();
  });
};
